module.exports = "<div class=row id=admin-politics-index> <div class=col-xs-12> <div class=page-header> <a ng-href=/admin/politics/add class=\"btn btn-default pull-right\">Add New</a> <h1>Politics</h1> </div> <table class=\"table table-striped\"> <thead> <tr> <th></th> <th>Name</th> </tr> </thead> <tbody> <tr ng-repeat=\"politic in politics\"> </tr> <tr ng-show=\"users.length === 0\"> <td colspan=5>no items matched</td> </tr> </tbody> </table> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./client/src/app/admin/politics/admin-politics.tpl.html
// module id = 256
// module chunks = 2